module.exports = __webpack_public_path__ + "img/2.99d614f6.svg";